const state = {
  quickOrderTheme: '',
  hasMyProcessingOrder: false // 是否有自己的进行中约单
};

const mutations = {
  SET_QUICKORDER_THEME: (state, themeName) => {
    state.quickOrderTheme = themeName;
  },
  SET_HAS_MY_PROCESSING_ORDER: (state, hasOrder) => {
    state.hasMyProcessingOrder = hasOrder;
  }
};

const actions = {
  setQuickOrderTheme({ commit }, themeName) {
    commit('SET_QUICKORDER_THEME', themeName);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
